import { createFontSizeCSS } from '@hellodarwin/core/web/theme/global-style';
import styled, { css } from 'styled-components';
export const HubspotFormLoadingState = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${({ $minHeight }) => $minHeight !== null && $minHeight !== void 0 ? $minHeight : 400}px;
`;
const getButtonStyle = (theme) => css `
  cursor: pointer;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  min-width: ${theme.buttons.width_medium};
  min-height: ${theme.buttons.height_medium};
  font-size: ${theme.fonts.button_medium};
  font-weight: 500;
  width: fit-content;
  padding: 0;
  color: ${theme.colors.white_1};
  background: ${theme.colors.purple_2};
  box-shadow: none;
  &:not([disabled]):hover {
    background: ${theme.colors.purple_3};
  }
`;
const getInputStyle = (theme) => css `
  border: 1px solid ${theme.colors.primary};
  background: ${theme.colors.white_1};
  ${createFontSizeCSS('body3')}
  color: ${theme.colors.primary};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  height: 48px;
  padding-inline: 16px;
  padding-block: 4px;
  width: 100%;
  &::placeholder,
  &.is-placeholder {
    color: ${theme.colors.grey_3};
  }
`;
const getLabelStyle = () => css `
  ${createFontSizeCSS('body2')}
  margin-block-end: 8px;
`;
const HubspotFormLegacyStyling = (theme) => css `
  form {
    margin-top: 16px;
    width: 100%;

    .actions {
      margin-block-start: 8px;
      display: flex;
      align-items: center;
      gap: 8px;
      justify-content: flex-end;
    }
    fieldset {
      max-width: 100%;
      &.form-columns-2,
      &.form-columns-1,
      &.form-columns-0 {
        .input {
          margin-block-end: 16px;
        }
      }
      &.form-columns-2 .input {
        margin-inline-end: 16px;
      }
    }
    .hs-form-field {
      label {
        ${getLabelStyle()}
      }
      input,
      select {
        ${getInputStyle(theme)}
      }
    }
    button,
    .hs-button {
      ${getButtonStyle(theme)}
    }
  }
`;
const HubspotFormModernStyling = (theme) => css `
  .hsfc-Renderer {
    h2.hsfc-Heading {
      ${createFontSizeCSS('h3')}
    }
    h3.hsfc-Heading {
      ${createFontSizeCSS('h4')}
    }
    h4.hsfc-Heading {
      ${createFontSizeCSS('h5')}
    }
    h5.hsfc-Heading {
      ${createFontSizeCSS('h6')}
    }
    .hsfc-Heading {
      font-family:
        'Figtree',
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        Roboto,
        'Helvetica Neue',
        sans-serif !important;
      font-weight: 600 !important;
      margin-block-end: 0;
    }
    .hsfc-Row {
      margin-block-end: 16px;
    }
    input,
    select {
      ${getInputStyle(theme)}
    }

    label {
      ${getLabelStyle()}
    }

    input[type='checkbox'] {
      width: 32px;
      height: 32px;
    }
    .hsfc-Button {
      ${getButtonStyle(theme)}
    }
  }
`;
export const StyledHubspotFormContainer = styled.div `
  ${({ theme, $isLegacy }) => $isLegacy
    ? HubspotFormLegacyStyling(theme)
    : HubspotFormModernStyling(theme)}
`;
